import IztMeetingCard from './src/izt-meeting-card.vue'

IztMeetingCard.install = Vue => {
  Vue.component(IztMeetingCard.name, IztMeetingCard)
}

export default IztMeetingCard